<template>
    <box :hideable="true">
        <h3 slot="header">
            <i class="fas fa-microphone"></i> {{resource('AnalysisSelection_Index_Calls_Header')}}
        </h3>
        <div slot="body">
            <div class="grid-container calls">

                <div class="grid-item-bottom-right">
                    <button class="btn btn-primary" @click="processCalls()" :disabled="analysisDisabled">
                        {{resource('AnalysisSelection_Index_SelectCalls_Button_DisplayName')}}
                    </button>
                </div>

                <div class="grid-item-calls-table">
                    <DataTable class="table table-striped"
                        :columns="columns"
                        :data="enrichedValue"
                        :loading="loading"
                        :datatableOptions="datatableOptions"
                        :options="options"
                        @selected="addCall($event)"
                        @unselected="removeCall($event)"
                        @select-all="selectAll($event)"
                        @unselect-all="unselectAll($event)"
                    />
                </div>

                <div class="grid-item-bottom-right">
                    <button class="btn btn-primary" @click="processCalls()" :disabled="analysisDisabled">
                        {{resource('AnalysisSelection_Index_SelectCalls_Button_DisplayName')}}
                    </button>
                </div>

            </div>
        </div>
    </box>
</template>

<script>

import api from '../api';
import _ from 'lodash';
import {sprintf} from 'sprintf-js';
import growler from '../../../../../Core/Util/growler';
import {secondsToTimeString, dateToString} from '../Util/calls';

//Components
import BootstrapBox from '../../../../../Core/Components/Util/BootstrapBox.vue';
import DataTable from '../../../../../Core/Components/Util/DataTable/DataTable.vue';

//Mixins
import callsTableMixin from '../Mixins/calls-table'
import resourceMixin from '../../../../../Core/Util/Mixins/resources';
import cultureMixin from '../../../../../Core/Util/Mixins/culture';

export default {
    name: 'analysis-selectiuon-calls',
    mixins: [resourceMixin, cultureMixin, callsTableMixin],
    components: {
        'Box': BootstrapBox,
        DataTable
    },
    methods: {
        processCalls() {
            const vm = this;
            vm.processing = true;
            vm.$emit('loading');
            
            api.insertCalls(vm.selectedCalls).then(
                processedCalls => {
                    const processedIds = processedCalls.map(call => call.callId);
                    vm.$emit('processed', processedIds);
                    vm.unselectAll();

                    growler.bootstrapSuccess(
                        sprintf(
                            vm.resource(
                                'AnalysisSelection_Index_CallsSelected_Success'
                            ), processedIds.length)
                        );
                    vm.processing = false;
                    vm.$emit('done');
                },
                error => {
                    growler.bootstrapDanger(error);
                    vm.processing = false;
                    vm.$emit('done');
                }
            );
        }
    },
    computed: {
        enrichedValue() {
            const vm = this;

            return _.map(vm.value, function(item) {
                item.contactDateString = dateToString(item.contactDate);
                item.durationString = secondsToTimeString(item.duration);
                item.saleString = item.sale ? vm.resource('Bool_Yes') : vm.resource('Bool_No');
                item.callCodeCombined = `${item.callCode} / ${item.callCodeDescription}`;
                item.DT_RowId = item.callId
                return item;
            });
        },
        analysisDisabled() {
            return (this.selectedCalls.length === 0) || this.processing;
        }
    },
    data() {
        const vm = this;

        return {
            columns: [
                { title: vm.resource('AnalysisSelectionResultModel_ContactDate_DisplayName'), data: 'contactDateString'},
                { title: vm.resource('AnalysisSelectionResultModel_AgentName_DisplayName'), data: 'agentName'},
                { title: vm.resource('AnalysisSelectionResultModel_DivisionName_DisplayName'), data: 'divisionName'},
                { title: vm.resource('AnalysisSelectionResultModel_Duration_DisplayName'), data: 'durationString'},
                { title: vm.resource('AnalysisSelectionResultModel_CallCode_DisplayName'), data: 'callCodeCombined'},
                { title: vm.resource('AnalysisSelectionResultModel_Sale_DisplayName'), data: 'saleString'},
                { data: 'contactDate', visible: false},
                { data: 'divisionId', visible: false},
                { data: 'callId', visible: false},
                { data: 'agentId', visible: false},
                { data: 'duration', visible: false},
                { data: 'sale', visible: false},
                { data: 'callCode', visible: false},
                { data: 'callCodeDescription', visible: false}],
            datatableOptions: { lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]] },
            options: { select: { enabled: true } },
            processing: false
        };
    },
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        value: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped src="../Style/analysis-selection.scss">

</style>